<template>
  <div class="advertising-analysis">
    <gj-analysis-panel
        :title="'广告分析'"
    >
      <template #subtitle>
        <gj-help :left="'4px'" :list="[
          '数据来源：亚马逊业务报告',
          '说明：按国家店铺查找时，使用按日期流量数据；按品类、运营状态查找时，使用按商品MSKU流量数据'
        ]">
        </gj-help>
         <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh','setting']"
            @refresh="refresh"
            @openCustomColumnModal="openCustomColumnModal"
        />
      </template>
      <template #panelBody>
        <OptionPanelShow :loading="loadingTop" :data="analysisMarketData" />
        <div class="advertising-analysis-content">
          <el-row :gutter="10" v-loading="loadingMiddle">
            <el-col :span="8">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>{{ "广告订单" }}</span>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.spsAdsOrdersPercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'商品广告' + analysisMarketTypeData.spsAdsOrders}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.sdsAdsOrdersPercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'展示广告' + analysisMarketTypeData.sdsAdsOrders}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.sbsAdsOrdersPercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'品牌广告' + analysisMarketTypeData.sbsAdsOrders}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>{{ "广告销售额" }}</span>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.spsSalePercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'商品广告' + analysisMarketTypeData.currencySymbol + analysisMarketTypeData.spsSale}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.sdsSalePercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'展示广告' + analysisMarketTypeData.currencySymbol + analysisMarketTypeData.sdsSale}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.sbsSalePercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'品牌广告' + analysisMarketTypeData.currencySymbol + analysisMarketTypeData.sbsSale}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>{{ "广告花费" }}</span>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.spsCostPercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'商品广告' + analysisMarketTypeData.currencySymbol + analysisMarketTypeData.spsCost}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.sdsCostPercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'展示广告' + analysisMarketTypeData.currencySymbol + analysisMarketTypeData.sdsCost}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="progress-group">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-progress :text-inside="true" :stroke-width="14" :percentage="analysisMarketTypeData.sbsCostPercent"></el-progress>
                    </el-col>
                    <el-col :span="10">
                      <span>{{'品牌广告' + analysisMarketTypeData.currencySymbol + analysisMarketTypeData.sbsCost}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <template>
            <gj-table
                style="height: 350px;margin-top: 20px"
                :name="'tableName'"
                :width="'100%'"
                :adapt-height="false"
                :height="300"
                ref="gjTable"
                :index="false"
                :data="data"
                border
                :loading="loadingBottom"
                :pagination="pagination"
                :columns="columns"
                :default-sort="{prop: 'impressions', order: 'descending'}"
                @sort-change="$gjSortChange"
                @page-change="$gjNoticeQuery"
            >
              <template v-slot:marketName="{row}">
                <gj-tooltip
                    :text-line="2"
                    :content="`${row.marketName} :${row.country}`">
                  {{ `${row.marketName} :${row.country}` }}
                </gj-tooltip>
              </template>
              <template v-slot:impressions="{row}">
                {{ row.impressions }}
                <ChainRatio :itemKey="'impressions'" :isBlock="true" :percent="parseInt(row.impressionsCompare)"/>
              </template>
              <template v-slot:clicks="{row}">
                {{ row.clicks }}
                <ChainRatio :itemKey="'clicks'" :isBlock="true" :percent="parseInt(row.clicksCompare)"/>
              </template>
              <template v-slot:ctr="{row}">
                {{ row.ctr + "%"}}
                <ChainRatio :itemKey="'ctr'" :isBlock="true" :percent="parseInt(row.ctrCompare)"/>
              </template>
              <template v-slot:cost="{row}">
                {{row.currencySymbol}}{{ row["cost"] | amount | defaultShow }}
                <ChainRatio :itemKey="'cost'" :isBlock="true" :percent="parseInt(row.costCompare)"/>
              </template>
              <template v-slot:cpc="{row}">
                {{ row.currencySymbol }}{{ row["cpc"] | amount | defaultShow }}
                <ChainRatio :itemKey="'cpc'" :isBlock="true" :percent="parseInt(row.cpcCompare)"/>
              </template>
              <template v-slot:adsOrders="{row}">
                {{ row.adsOrders }}
                <ChainRatio :itemKey="'adsOrders'" :isBlock="true" :percent="parseInt(row.adsOrdersCompare)"/>
              </template>
              <template v-slot:cpa="{row}">
                {{ row.currencySymbol }}{{ row["cpa"] | amount | defaultShow }}
                <ChainRatio :itemKey="'cpa'" :isBlock="true" :percent="parseInt(row.cpaCompare)"/>
              </template>
              <template v-slot:cvr="{row}">
                {{ row["cvr"] }}%
                <ChainRatio :itemKey="'cvr'" :isBlock="true" :percent="parseInt(row.ctrCompare)"/>
              </template>
              <template v-slot:adsSales="{row}">
                {{ row.currencySymbol }}{{ row["adsSales"] | amount | defaultShow }}
                <ChainRatio :itemKey="'adsSales'" :isBlock="true" :percent="parseInt(row.adsSalesCompare)"/>
              </template>
              <template v-slot:acos="{row}">
                {{ row.acos + "%" }}
                <ChainRatio :itemKey="'acos'" :isBlock="true" :percent="parseInt(row.acosCompare)"/>
              </template>
              <template v-slot:acoas="{row}">
                {{ row.acoas  + "%"}}
                <ChainRatio :itemKey="'acoas'" :isBlock="true" :percent="parseInt(row.acoasCompare)"/>
              </template>
              <template v-slot:asoas="{row}">
                {{ row.asoas  + "%"}}
                <ChainRatio :itemKey="'asoas'" :isBlock="true" :percent="parseInt(row.asoasCompare)"/>
              </template>
              <template v-slot:roas="{row}">
                {{ row.roas + "%" }}
                <ChainRatio :itemKey="'roas'" :isBlock="true" :percent="parseInt(row.roasCompare)"/>
              </template>
            </gj-table>
          </template>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>
import OptionPanelShow from "@/views/components/option-panel-show/option-panel-show"
import OptionGroup from "@/views/components/option-panel-group/option-group"
import {getAnalysisMarketData,getAnalysisMarketTypeData,getStoreAnalyzeAdsInfo} from "@/api/statistics"
import {getCustomColumns} from "@/api/common";
import _ from "lodash";
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"
import {queryMixin} from "@/minxins";
import {convertToFullDate, dateShortcut} from "@/utils/date.util";

export default {
  name: "advertising-analysis",
  inject: ['getPageParams'],
  mixins: [queryMixin],
  data() {
    return {
      useCache: false,
      settingName: 'advertisingAnalysis',
      loadingTop: false,
      loadingMiddle: false,
      loadingBottom: false,
      analysisMarketData: [],
      analysisMarketAllData: {},
      analysisMarketTypeData: {},
      data: [],
      sort: {
        order: 'descending',
        prop: "impressions"
      },
      columns: [
        {id: 'marketName', header: '店铺/国家', field: 'slot:marketName', minWidth: '180px', align: 'left'},
        {id: 'impressions', sortable: true, header: '曝光量', field: 'slot:impressions', minWidth: '100px', align: 'right'},
        {id: 'clicks', sortable: true, header: '点击量', field: 'slot:clicks', minWidth: '100px', align: 'right'},
        {id: 'ctr', sortable: true, header: 'CTR', field: 'slot:ctr', minWidth: '100px',align: 'right'},
        {id: 'cost', sortable: true, header: '广告花费', field: 'slot:cost', minWidth: '100px',align: 'right'},
        {id: 'cpc', sortable: true, header: 'CPC', field: 'slot:cpc', minWidth: '100px',align: 'right'},
        {id: 'adsOrders', sortable: true, header: '广告总订单量', field: 'slot:adsOrders', minWidth: '120px',align: 'right'},
        {id: 'cvr', sortable: true, header: 'CVR', field: 'slot:cvr', minWidth: '100px',align: 'right'},
        {id: 'cpa', sortable: true, header: 'CPA', field: 'slot:cpa', minWidth: '100px',align: 'right'},
        {id: 'adsSales', sortable: true, header: '广告总销售额', field: 'slot:adsSales', minWidth: '120px',align: 'right'},
        {id: 'acos', sortable: true, header: 'ACOS', field: 'slot:acos', minWidth: '100px',align: 'right'},
        {id: 'acoas', header: 'ACOAS', field: 'slot:acoas', minWidth: '100px',align: 'right'},
        {id: 'asoas', header: 'ASOAS', field: 'slot:asoas', minWidth: '100px',align: 'right'},
        {id: 'roas', sortable: true, header: 'ROAS', field: 'slot:roas', minWidth: '100px',align: 'right'},
      ],
      moduleColumns: [
        {label: "曝光量", key: "impressions", sortIndex: 1, default: true  },
        {label: "点击量", key: "clicks", sortIndex: 2, default: true },
        {label: "CTR", key: "ctr", suffix: '%',sortIndex: 3 },
        {label: "广告花费", key: "cost", prefix: 'currencySymbol',sortIndex: 4, default: true },
        {label: "CPC", key: "cpc", sortIndex: 5 },
        {label: "广告订单量", key: "adsOrders", sortIndex: 6, default: true  },
        {label: "广告CVR", key: "cvr", suffix: '%',sortIndex: 7, default: true },
        {label: "广告销售额", key: "adsSales", prefix: 'currencySymbol',sortIndex: 8 , default: true },
        {label: "ACOS", key: "acos", suffix: '%',sortIndex: 9 },
        {label: "ACOAS", key: "acoas", suffix: '%',sortIndex: 10 },
        {label: "ASOAS", key: "asoas", suffix: '%',sortIndex: 11 },
        {label: "ROAS", key: "roas", suffix: '%',sortIndex: 12, default: true },
      ],
    }
  },
  created() {
    this.sort.prop = "impressions"
    this.getData()
    this.$gjQuery()
  },
  components: { OptionPanelShow,OptionGroup,ChainRatio },
  computed: {
    startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    filter () {
      return this.getPageParams()
    }
  },
  methods:{
    /**
     * 刷新操作
     */
    refresh(){
      this.getData();
      this.$gjQuery()
    },
    $gjQueryInitParams() {
      return {

      }
    },
    /**
     * 获取全部初始化界面数据
     */
    $gjQuery(){
      this.getStoreAnalyzeAdsInfoData();
    },
    getData() {
      //获取概览自定义列
      this.getCustomColumns();

      this.getAnalysisMarketData();
      this.getAnalysisMarketTypeData();
    },
    /**
     * 获取自定义列
     */
    getCustomColumns(){
      getCustomColumns(this.settingName).then(res =>{
        let list = res ? res.split(",") : null;
        this.analysisMarketData = res ? this.moduleColumns.filter(e => _.includes(list, e.key)) : this.moduleColumns.filter(e => e.default);
        this.moduleColumns = res ? this.moduleColumns.map(e => {
          if (_.includes(list, e.key)) {
            e.checked = true;
          } else {
            e.checked = false;
          }
          return e;
        }) : this.moduleColumns.map(e => {
          if (e.default) {
            e.checked = true;
          } else {
            e.checked = false;
          }
          return e;
        })
      })
    },
    /**
     * 打开设置弹窗
     */
    openCustomColumnModal(){
      let _this = this;
      this.$gjCreate('gj-setting-custom-modal', {
        props: {
          name: this.settingName,
          size: 'middle',
          title: '最多可以选择7个指标，至少选中1个指标',
          customStr: "impressions,clicks,ctr,adsOrders,adsSales,cvr,cost,cpc,acos,roas,asoas,acoas",
          allowNum: 7,
          moduleColumns: _this.moduleColumns
        },
        on: {
          ["moduleColumns"](moduleColumns){
            _this.moduleColumns = moduleColumns;
          },
          ['check-list-items'](columns) {
            _.map(columns, v=>{
              v.value = _this.analysisMarketAllData[v.key];
              let compareKey = v.key + "Compare";
              v.percent = _this.analysisMarketAllData[compareKey];
              v.currencySymbol = _this.analysisMarketAllData['currencySymbol'];
              return v;
            })
            _this.analysisMarketData = columns;
          }
        }
      });
    },
    /**
     * 获取广告分析-店铺汇总统计
     */
    getAnalysisMarketData(){
      const _this = this;
      this.loadingTop = true;
      let params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      }
      params = _.omit(params,["date","countryMarketValue","id"]);
      getAnalysisMarketData(params).then((res) =>{
        let data = res;
        this.analysisMarketAllData = data;
        _this.analysisMarketData = _.map(_this.analysisMarketData, v=>{
          v.value = data[v.key];
          let compareKey = v.key + "Compare";
          v.percent = data[compareKey];
          v.currencySymbol = data['currencySymbol'];
          return v;
        });
      }).complete(()=>{this.loadingTop = false;})
    },
    /**
     * 获取广告分析-店铺按类型统计
     */
    getAnalysisMarketTypeData(){
      this.loadingMiddle = true;
      let params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      }
      params = _.omit(params,["date","countryMarketValue","id"]);
      getAnalysisMarketTypeData(params).then((res) =>{
        let data = res;
        //前端拿到数据算出比例值，塞入原数据
        data.spsAdsOrdersPercent != 0 && data.totalAdsOrders != 0 && (data.spsAdsOrdersPercent = _.floor(_.toNumber(data.spsAdsOrders)/_.toNumber(data.totalAdsOrders) * 100))
        data.sdsAdsOrdersPercent != 0 && data.totalAdsOrders != 0 && (data.sdsAdsOrdersPercent = _.floor(_.toNumber(data.sdsAdsOrders)/_.toNumber(data.totalAdsOrders) * 100))
        data.sbsAdsOrdersPercent != 0 && data.totalAdsOrders != 0 && (data.sbsAdsOrdersPercent = _.floor(_.toNumber(data.sbsAdsOrders)/_.toNumber(data.totalAdsOrders) * 100))
        data.spsSalePercent != 0 && data.totalSale != 0 && (data.spsSalePercent = _.floor(_.toNumber(data.spsSale)/_.toNumber(data.totalSale) * 100))
        data.sdsSalePercent != 0 && data.totalSale != 0 && (data.sdsSalePercent = _.floor(_.toNumber(data.sdsSale)/_.toNumber(data.totalSale) * 100))
        data.sbsSalePercent != 0 && data.totalSale != 0 && (data.sbsSalePercent = _.floor(_.toNumber(data.sbsSale)/_.toNumber(data.totalSale) * 100))
        data.spsCostPercent != 0 && data.totalCost != 0 && (data.spsCostPercent = _.floor(_.toNumber(data.spsCost)/_.toNumber(data.totalCost) * 100))
        data.sdsCostPercent != 0 && data.totalCost != 0 && (data.sdsCostPercent = _.floor(_.toNumber(data.sdsCost)/_.toNumber(data.totalCost) * 100))
        data.sbsCostPercent != 0 && data.totalCost != 0 && (data.sbsCostPercent = _.floor(_.toNumber(data.sbsCost)/_.toNumber(data.totalCost) * 100))
        this.analysisMarketTypeData = data;
      }).complete(()=>{ this.loadingMiddle = false;})
    },
    /**
     * 获取广告分析-分页查询店铺分析
     */
    getStoreAnalyzeAdsInfoData(){
      const params = {
        model: {
          ...this.filter,
          countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
          marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
        },
        ...this.queryPagination,
        ...this.querySort
      };
      this.loadingBottom = true;
      getStoreAnalyzeAdsInfo(params).then((res)=>{
        let data = res.records;
        this.data = data;
        this.pagination = this.getPagination(res);
      }).complete(()=>{this.loadingBottom = false;});
    },
    getPagination(queryResponse) {
      return {
        currentPage: queryResponse.current,
        pageSize: queryResponse.size,
        total: queryResponse.total,
      };
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../common/index.scss";
.advertising-analysis{
  margin-top: 10px;
  //padding: 40px 0px 0 0px;
  //margin-top: -40px;
}
.advertising-analysis-content{
  width: 100%;
}
.progress-group{
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;


}
.el-col-10{
   span{
     font-size: 14px;
   }
}
/deep/ .el-progress-bar__innerText {
  margin-bottom: 3px;
}
</style>
